// Internal modules
import { fetchContentAndMetadata, logger, updateLocale } from '@/lib';
import { appStore } from '@/store';
import {
  queryCookieBanner,
  removeCookieBanner,
  setCookieBanner,
} from '../../shared';

const handleLanguageChange = (language: string): void => {
  logger.fpti('weasley_language_changed', {
    change_to_lang: language,
    state_name: 'signup',
    transition_name: 'language_change',
  });

  removeCookieBanner();
  updateLocale({ language });
  appStore.getActions().ui.setCurrentLanguage(language);
  fetchContentAndMetadata();
  // @ts-expect-error Check the error and undefined cases
  queryCookieBanner().then(setCookieBanner);
};

export { handleLanguageChange };
